import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import Link from "./link"
import Spacer from "./spacer"
const CtaModule = ({ title, buttonText, buttonLink, video, image }) => {
  return (
    <div className='image--banner ml60 p40 m-m0 m-p0 pos-rel overflow'>
      <div className='aspect-2-1 m-h100vh fade--up align-center justify-center flex bg-grey pos-rel m-ratio-2-3 m-100 overflow m-h100 m-flex' data-sal>
        <div className='pos-rel z-2 flex flex-col justify-center align-center items-center p40 white m-text-center m-100 m-mb40 m-p20'>
          <div className='max-700 ma text-center'>
            {title && <h2 className='white mb40 balance'>{title}</h2>}
            {buttonLink && buttonText && (
              <Link to={buttonLink} className='button link wide white-btn'>
                {buttonText}
              </Link>
            )}
          </div>
        </div>
        <GatsbyImage image={image?.gatsbyImageData} alt={title} className='bg-image op-80' />
        {video && (
          <video id='video' loop={true} playsInline={true} muted={true} autoPlay={true} className='bg-image cover op-80' allowFullScreen>
            <source src={video} />
          </video>
        )}
      </div>
      <Spacer />
    </div>
  )
}

export default CtaModule
